export default __webpack_public_path__ + "static/media/Snd_3.5b21dce7.mp3";